import backend from '@/common/backend';

/**
 * 申込削除
 */
export function orderDelete(orderNo, navigate, doShowMessage) {

  // 削除確認メッセージ
  doShowMessage({
    message: { id: 'BFY000005C', values: ['作成中の申込を削除']},
    action: () => handleDelete(orderNo, navigate, doShowMessage),
  });
}

//
// 削除実行
//
async function handleDelete(orderNo, navigate, doShowMessage) {

  // 申込削除
  const res = await backend.post('/bfa10102g/delete/' + orderNo.path());
  if (!res.parse(doShowMessage).ok) {
    return;
  }

  // 削除終了メッセージ
  doShowMessage({
    message: { id: 'BFY000009I', values: ['削除'] },

    // 申込一覧に戻る
    action: () => navigate('/bfa10101g'),
  });
}
